import React from 'react';
import moment from 'moment';

//css

import '../assests/css/dashboard.css'
//icons
import { FaCalendarAlt, FaCaretDown } from 'react-icons/fa';

//datepicker 
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

function DateRangeComponent({handleDateRange}) {

    return (
        <div className="col-md-6 my-auto pl-5 align-item-center" style={{ display: "flex" }}>
            <small style={{ alignSelf: "center" }}>Select Date Range</small>&nbsp;&nbsp;&nbsp;
            <DateRangePicker
                autoUpdateInput={false}
                initialSettings={{
                    startDate: moment(localStorage.getItem('start-date'), "MM/DD/YYYY"),
                    endDate: moment(localStorage.getItem('end-date'), "MM/DD/YYYY"),
                    maxDate: moment(),
                    ranges: {
                        'Today': [moment(), moment()],
                   //     'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Current Week': [moment().startOf('week'), moment()],
                        'Last Week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                   // 'Last 2 Weeks': [moment().subtract(2, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                        'This Year': [moment().startOf('year'), moment().endOf('year')],
                        'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
 
                    },
                    alwaysShowCalendars: true,
                }}
                locale={{
                    'format': 'DD/MM/YYYY'
                }}
                autoApply={true}
                onApply={(startDate, endDate) => handleDateRange(startDate, endDate)}
            >
                <button style={{ fontSize: "small", border: "1px solid lightgray", borderRadius: "15px", padding: "4px" }} >
                    <span style={{ marginBottom: "4px", marginLeft: "5px" }}><FaCalendarAlt margin-bottom="4px" color="#2596BE" fontSize="medium" margin-left="4px" /></span>&nbsp;
                    <span style={{ padding: "10px" }}>{localStorage.getItem('start-date')} - {localStorage.getItem('end-date')}</span>
                    <FaCaretDown />  
                </button>
            </DateRangePicker>
        </div>

    );
}

export default DateRangeComponent;